
// import axios from 'axios'
// import Message from 'element-ui'
import router from '@/router'

//
/**
 * 由管理员创建。
 */
import axios from 'axios'
import { getToken } from '@/utils/auth'
import website from '@/config/website'
import { Message } from 'element-ui'

function isOnLine() { // 判断网络状态
    let netStatus = ''
    if (window.navigator.onLine === true) {
        netStatus = 'onLine'// 网络链接正常
    } else {
        netStatus = 'offLine'// 网络连接失败
    };
    return netStatus
};

axios.defaults.timeout = 5000 // 设置请求超时的时间
// 设置访问的域名前缀
// axios.defaults.baseURL = process.env.BASE_URL
axios.defaults.baseURL = ''
axios.defaults.withCredentials = false // 发送请求时是否携带cookie

// http request 拦截器
axios.interceptors.request.use(config => {
    // const meta = (config.meta || {})
    // const isToken = meta.isToken === false
    config.data = JSON.stringify(config.data)
    // 设置请求头
    // console.log('http request 拦截器', config)
    // config.headers['Authorization'] = 'Basic c3dvcmQ6c3dvcmRfc2VjcmV0'
    // config.headers['Tenant-Id'] = 690547
    // config.headers['Captcha-Key'] = '578a82c5-3663-4bde-a39f-3c0d06397bc1'
    // 让每个请求携带token
    // if (getToken() && !isToken) {
    // if (getToken()) {
    //     // Blade-Auth
    //     config.headers[website.tokenHeader] = 'bearer ' + getToken()
    //     console.log('输出cookie', website.tokenHeader)
    // }
    // headers中配置text请求
    if (config.text === true) {
        config.headers['message-Type'] = 'text/plain'
    }
    config.credentials = 'include'
    return config
}, error => {
    console.log('请求失败', error)
    return Promise.reject(error)
})

// http response 拦截器
axios.interceptors.response.use(response => {
    console.log('axios-response', response)

    if (response.data.errCode === 2) {
        router.push({
            path: '/',
            querry: { redirect: router.currentRoute.fullPath }// 从哪个页面跳转
        })
    }
    return response
}, error => {
    const { response } = error
    if (response) {
        errorHandle(response.status)
        if (response.status === 401) {
            router.push('home')
        }
    } else {
        if (isOnLine() === 'offLine') {
            Message({
                message: '网络异常',
                type: 'warning'
            })
        } else {
            Message({ message: '请求失败，请重试' })
        }
    }
    return Promise.reject(error)
})

/**
  * 封装get方法
  * @param url
  * @param data
  * @returns {Promise}
  */
export function get(url, params = {}) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params
        })
            .then(response => {
                resolve(response)
            })
            .catch(err => {
                reject(err)
            })
    })
}

/**
  * 封装post请求
  * @param url
  * @param data
  * @returns {Promise}
  */
export function post(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.post(url, data)
            .then(response => {
                resolve(response.data)
            }, err => {
                reject(err)
            })
    })
}

/**
 * 状态码判断 具体根据当前后台返回业务来定
 * @param {*请求状态码} status
 * @param {*错误信息} err
 */
const errorHandle = (status, err) => {
    switch (status) {
        case 401:
            Message({
                message: '你还未登录'
            })
            break
        case 400:
            Message({
                type: 'error',
                message: '累计错误已达5次，锁定账户30分钟'
            })
            break

        case 404:
            Message({
                message: '请求路径不存在'
            })
            break
        case 500:
            Message({
                message: '系统繁忙，请稍后重试'
            })
            break
        default:
            Message({
                message: '网络错误', type: 'error'
            })
    }
}



// WEBPACK FOOTER //
// ./src/utils/apiAxios.js